import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    captcha: (state) => state.captcha,
  }),
  ...mapGetters('auth', [
    'loggedIn',
    'getError',
    'getCaptchaInfo',
    'getCurrentUser',
    'getRole',
    'getForgot',
  ]),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'reCaptchaKeys',
  'fetchingForgot',
])

export const confirmComputed = {
  ...mapState('confirm', {
    messages: (state) => state.messages,
    title: (state) => state.title,
    ranOutSession: (state) => state.ranOutSession,
  }),
  ...mapGetters('confirm', ['errorConfirmed', 'sessionIsEnded']),
}

export const confirmMethods = mapActions('confirm', ['reset'])
